import {Routes} from '@angular/router';
import {TechniciansComponent} from '@pages/users/technicians/technicians.component';
import {UserProfileComponent} from '@pages/users/user-profile/user-profile/user-profile.component';
import {QrcodeComponent} from '@pages/users/technicians/qrcode/qrcode.component';

export const USERS_ROUTES: Routes = [
  {
    path: 'technicians',
    component: TechniciansComponent,
    data: {
      title: 'Field Technicians ',
      urls: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Field Technicians' },
      ],
    }
  },
  {
    path: 'user-profile',
    component: UserProfileComponent,
    data: {
      title: 'Account',
      urls: [
        {title: 'Dashboard', url: '/dashboard'},
        {title: 'Account'},
      ],
    }
  },
  {
    path: 'qrcode',
    component: QrcodeComponent,
    data: {
      title: 'Qr code',
      urls: [
        {title: 'Dashboard', url: '/dashboard'},
        {title: 'Qr Code'},
      ],
    }
  }
];
